import jQuery from "jquery";

/*
 * Inline <script> blocks in content/*.php — and any third-party callback that
 * expects the classic globals — still reach for $ / jQuery on window, so keep
 * them attached even though everything in src/ imports the module directly.
 */
window.$ = window.jQuery = jQuery;

export default jQuery;
